<template>
  <div v-if="tabs.length > 0" class="vcv-settings-tabs">
    <div
      v-for="item in tabs"
      :key="item.id"
      :class="{ active: activeTab === item.id }"
      class="vcv-settings-tabs__tab"
      @click="$emit('change', item.id)"
    >
      <span class="vcv-settings-tabs__text">
        {{ item.title }}
      </span>

      <img
        v-if="item.tooltip !== undefined && item.tooltip"
        v-tooltip="{
          content: item.tooltip,
          placement: 'top-center',
          classes: 'tight'
        }"
        class="vcv-settings-tabs__tooltip"
        src="/static/images/elements/vmodule-icon-info.svg"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VcvSettingsTabs',

  props: {
    tabs: {
      type: Array,
      default: () => []
    },

    activeTab: {
      type: String,
      default: ''
    }
  },

  created() {
    if (!this.activeTab && this.tabs.length > 0) {
      this.$emit('change', this.tabs[0].id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vcv-settings-tabs {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  &__tab {
    @include mixin-text-main;
    padding: 12px 10px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 1px solid $grey-light;
    border-left: none;
    background: #fff;
    position: relative;
    cursor: pointer;

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: transparent;
      transition: background 0.3s;
    }

    &:first-child {
      border-left: 1px solid $grey-light;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }

    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    &.active:before {
      background: $green;
      transition: background 0.3s;
    }
  }

  &__tooltip {
    margin-left: 5px;
  }
}
</style>
